import { 
    ADD_MEMBER_ROLE, 
    CREATE_ROLE, 
    DELETE_ROLE, 
    DETAIL_ROLE, 
    EXPORT_ROLE, 
    IMPORT_ROLE, 
    UPDATE_ROLE,
    LIST_ROLE,
    GET_ROLE_LIST, 
    DELETE_MEMBER_ROLE,
    PAGE_LIST_ROLE,
    DELETE_MULTIPLE_ROLE,
    GET_ROLE_LIST_ALL,
    GET_LIST_SERVICE_ROLE
} from "shared/constants/ActionTypes";

const pageListRole ={
    page:0,
    pageSearch:0,
    textSearch:''
}
const ListRole = {
    count: 0,
    limit: null,
    message: null,
    next: null,
    previous: null,
    results: [],
    status:null
  }

const initialState = {
    roleList: null,
    roleListAll: null,
    addMemberRole: null,
    detailRole: null,
    createRole: null,
    deleteRole: null,
    updateRole: null,
    exportRole: null,
    importRole: null,
    serviceRoleList: null,
    deleteMemberRole: null,
    deleteMultipleRole: null,
    listRole: ListRole,
    pageListRole:pageListRole,
};

const roleReducer = (state=initialState,action) => {
    switch (action.type) {
        case GET_ROLE_LIST:
            return {
                ...state,
                roleList: action.payload
            }
            case GET_ROLE_LIST_ALL:
                return {
                    ...state,
                    roleListAll: action.payload
                }
        case LIST_ROLE:
            return {
                ...state,
                listRole:action.payload
            }
        case DETAIL_ROLE:
            return {
                ...state,
                detailRole:action.payload
            }
        case ADD_MEMBER_ROLE:
            return {
                ...state,
                addMemberRole:action.payload
            }
        case DELETE_MEMBER_ROLE:
            return {
                ...state,
                deleteMemberRole:action.payload
            }
        case CREATE_ROLE:
            return {
                ...state,
                createRole:action.payload
            }
        case UPDATE_ROLE:
            state.detailRole = action.payload
            return {
                ...state,
                updateRole:action.payload
            }
        case DELETE_ROLE:
            return {
                ...state,
                deleteRole:action.payload
            }
        case IMPORT_ROLE:
            return {
                ...state,
                importRole:action.payload
            }
        case EXPORT_ROLE:
            return {
                ...state,
                exportRole:action.payload
            }
        case PAGE_LIST_ROLE:
            return {
                ...state,
                pageListRole:action.payload
            }
        case GET_LIST_SERVICE_ROLE:
            return {
                ...state,
                serviceRoleList:action.payload
            }    
        case DELETE_MULTIPLE_ROLE:
            return {
                ...state,
                deleteMultipleRole:action.payload
            }
        default:
            return {
                ...state
            }
    }
};

export default roleReducer;